'use client';
import { Avatar as SharedAvatar } from '@launchstore/shared-puck';
import type { AvatarProps } from '@launchstore/shared-puck';
export const Avatar: any = SharedAvatar;
export type { AvatarProps };
export default Avatar;
